import script from "./PlaylistCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistCatalog.vue?vue&type=script&setup=true&lang=js"

import "./PlaylistCatalog.vue?vue&type=style&index=0&id=6f530163&lang=css"

const __exports__ = script;

export default __exports__